angular.module("LeasePilot").controller("ApiController", [
  "$scope",
  "$http",
  "$mdToast",
  "railsResourceFactory",
  "railsSerializer",
  function($scope, $http, $mdToast, railsResourceFactory, railsSerializer) {
    var ApiService = railsResourceFactory({
      url: '/api/api',
      name: 'api',
      serializer: railsSerializer(function() {
        this.serializeWith(function(data) {
          return { api_token: data.apiToken };
        });
      })
    });

    $scope.loading = false;
    $scope.apiToken = null;
    $scope.showToken = false;

    function showToast(message, type = "success") {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(message)
          .position("top right")
          .hideDelay(3000)
          .theme(type === "error" ? "error-toast" : "success-toast")
      );
    }

    function handleError(error) {
      console.error("API Error:", error);
      if (error.status === 401) {
        showToast("Failed to generate API token", "error");
        return;
      }
      if (error.data && error.data.error) {
        const message = Array.isArray(error.data.error)
          ? error.data.error[0]
          : error.data.error;
        showToast(message, "error");
      } else {
        showToast("An unexpected error occurred", "error");
      }
    }

    $scope.loadApiToken = function() {
      $scope.loading = true;
      ApiService.$get("/api/api/get_token")
        .then(function(response) {
          $scope.apiToken = response.apiToken;
          $scope.loading = false;

          // The log only exists for companies that actually call the API.
          if ($scope.apiToken) {
            $scope.loadEventLog();
          }
        })
        .catch(function(error) {
          handleError(error);
          $scope.loading = false;
        });
    };

    $scope.generateNewToken = function() {
      if (!confirm("Warning: Generating a new API token will invalidate the current token. Are you sure you want to continue?")) {
        return;
      }

      $scope.loading = true;
      ApiService.$post("/api/api/generate_token")
        .then(function(response) {
          $scope.apiToken = response.apiToken;
          showToast("New API token generated successfully");
          $scope.loading = false;
          window.track.event(new GenerateNewApiTokenEvent());
        })
        .catch(handleError);
    };

    function copyText(value, message) {
      const textArea = document.createElement("textarea");
      textArea.value = value;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      showToast(message);
    }

    $scope.copyToClipboard = function() {
      copyText($scope.apiToken, "API token copied to clipboard");
    };

    // --- Event log ---------------------------------------------------------

    $scope.log = {
      loading: false,
      error: null,
      configured: true,
      events: [],
      failuresOnly: false,
      selectedEndpoint: ""
    };

    $scope.logEndpoints = [];
    $scope.filteredLogEvents = [];
    $scope.failureCount = 0;

    function applyLogFilters() {
      $scope.filteredLogEvents = $scope.log.events.filter(function(event) {
        if ($scope.log.failuresOnly && event.outcome === "success") {
          return false;
        }
        if (
          $scope.log.selectedEndpoint &&
          event.endpoint !== $scope.log.selectedEndpoint
        ) {
          return false;
        }
        return true;
      });

      $scope.failureCount = $scope.log.events.filter(function(event) {
        return event.outcome !== "success";
      }).length;
    }

    $scope.$watchGroup(
      ["log.failuresOnly", "log.selectedEndpoint"],
      applyLogFilters
    );

    $scope.outcomeLabel = function(event) {
      if (event.outcome === "success") return "Succeeded";
      if (event.outcome === "client_error") return "Rejected";
      return "Failed";
    };

    // The legend lives on the statuses rather than in a banner above the table,
    // so it costs no space until someone actually wants it.
    $scope.outcomeHint = function(event) {
      if (event.outcome === "client_error") {
        return "Turned away because of something in the request. The reason is shown under Details and is yours to fix.";
      }
      if (event.outcome === "server_error") {
        return "Did not complete on our side. We are alerted automatically — quote the reference to support to have it looked at.";
      }
      return "";
    };

    $scope.copyRequestId = function(event) {
      copyText(event.request_id, "Reference copied to clipboard");
    };

    $scope.loadEventLog = function() {
      $scope.log.loading = true;
      $scope.log.error = null;

      $http
        .get("/api/api_event_log")
        .then(function(response) {
          const events = (response.data && response.data.data) || [];

          $scope.log.configured = response.data.configured !== false;
          $scope.log.events = events.map(function(event) {
            // Tinybird returns UTC as "2026-08-14 09:00:00"; Safari will not
            // parse that without the separator and the zone marker.
            return angular.extend({}, event, {
              timestamp: new Date(
                String(event.timestamp).replace(" ", "T") + "Z"
              )
            });
          });

          const endpoints = new Set();
          $scope.log.events.forEach(function(event) {
            endpoints.add(event.endpoint);
          });
          $scope.logEndpoints = Array.from(endpoints).sort();

          applyLogFilters();
          $scope.log.loading = false;
        })
        .catch(function(error) {
          console.error(error);
          $scope.log.error =
            "Failed to load the API event log. Please try again.";
          $scope.log.loading = false;
        });
    };

    // Initialize
    $scope.loadApiToken();
  }
]); 